import React from 'react'
import './styles.scss'

interface ImagePreviewProps {
  base64Image: string
  altText?: string
}

const ImagePreview = (props: ImagePreviewProps): JSX.Element => {
  return (
    <React.Fragment>
      <img
        className='image-preview'
        src={props.base64Image}
        alt={props.altText}
      />
    </React.Fragment>
  )
}

export default ImagePreview
